import React, { useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import "./ThumbnailGallery.css";

function ThumbnailGallery({ images }) {
  const [activeImage, setActiveImage] = useState(images[0]);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const handleThumbnailClick = (img) => {
    setActiveImage(img);
  };

  const handleNext = () => {
    const currentIndex = images.indexOf(activeImage);
    const nextIndex = (currentIndex + 1) % images.length;
    setActiveImage(images[nextIndex]);
  };

  const handlePrevious = () => {
    const currentIndex = images.indexOf(activeImage);
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setActiveImage(images[prevIndex]);
  };

  const handleMainImageClick = () => {
    setIsOverlayOpen(true);
  };

  const handleCloseOverlay = () => {
    setIsOverlayOpen(false);
  };

  return (
    <div className="thumbnail-gallery-container">
      <button className="prev-button" onClick={handlePrevious}>
        <i className="fas fa-chevron-left"></i>
      </button>
      <div className="main-image-gallery" onClick={handleMainImageClick}>
        <img src={activeImage} alt="Ana Görsel" />
      </div>
      <button className="next-button" onClick={handleNext}>
        <i className="fas fa-chevron-right"></i>
      </button>

      {/* Thumbnail Görseller */}
      <div className="thumbnail-gallery">
        {images.map((img, index) => (
          <div
            key={index}
            className={`thumbnail-item ${img === activeImage ? "active" : ""}`}
            onClick={() => handleThumbnailClick(img)}
          >
            <img src={img} alt={`Görsel ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Overlay Tam Ekran Slider */}
      {isOverlayOpen && (
        <div className="overlay" onClick={handleCloseOverlay}>
          <CSSTransition
            in={isOverlayOpen}
            timeout={300}
            classNames="fade"
            unmountOnExit
          >
            <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-overlay" onClick={handleCloseOverlay}>
                &times;
              </button>
              <button className="prev-button" onClick={handlePrevious}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <SwitchTransition>
                <CSSTransition
                  key={activeImage}
                  timeout={300}
                  classNames="slide"
                >
                  <div className="main-image-overlay">
                    <img src={activeImage} alt="Tam Ekran Görsel" />
                  </div>
                </CSSTransition>
              </SwitchTransition>
              <button className="next-button" onClick={handleNext}>
                <i className="fas fa-chevron-right"></i>
              </button>

              {/* Thumbnail Görseller (Tam Ekran) */}
              <div className="thumbnail-gallery overlay-thumbnails">
                {images.map((img, index) => (
                  <div
                    key={index}
                    className={`thumbnail-item ${img === activeImage ? "active" : ""}`}
                    onClick={() => handleThumbnailClick(img)}
                  >
                    <img src={img} alt={`Görsel ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>
          </CSSTransition>
        </div>
      )}
    </div>
  );
}

export default ThumbnailGallery;